import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicHorizontalScroller from '../EpicHorizontalScroller/epic.horizontal.scroller.vue';
import EpicExploreCardA from '../EpicExploreCardA/epic.explore.card.agent.vue';

@Component({
    components: {
        EpicHorizontalScroller,
        EpicExploreCardA
    }
})
export default class EpicExploreNeighbour extends Vue {
    public title: string = 'EpicExploreNeighbour';

    @Prop({ default: undefined})
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
